"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var BorderLessInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\toutline: 0;\n\tborder: 0;\n\tmargin: 0;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tpadding: 6px;\n\tfont-size: 16px;\n"], ["\n\toutline: 0;\n\tborder: 0;\n\tmargin: 0;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tpadding: 6px;\n\tfont-size: 16px;\n"])));
exports.default = BorderLessInput;
var templateObject_1;